import * as React from 'react';
import { Text } from 'wix-ui-tpa';
import { TextPriority } from 'wix-ui-tpa/dist/src/components/Text/types';
import { classes } from './ExpandedTime.st.css';
import { useTranslation } from 'react-i18next';
import TimeIcon from './TimeIcon';
//utils
import { formatsByType, getRecurrenceByRule, } from '../ExpandedEvent/ExpandedEventUtils/ExpandedEventUtils';
var ExpandedTime = function (_a) {
    var startDate = _a.startDate, endDate = _a.endDate, _b = _a.recurrence, recurrence = _b === void 0 ? '' : _b, type = _a.type, originType = _a.originType, timeFormat = _a.timeFormat, weekStarter = _a.weekStarter, groupByStartDate = _a.groupByStartDate, experiments = _a.experiments, locale = _a.locale;
    var t = useTranslation()[0];
    var time = formatsByType[type]({
        startDate: startDate,
        endDate: endDate,
        originType: originType,
        timeFormat: timeFormat,
        t: t,
        experiments: experiments,
        locale: locale,
    });
    var recurrenceByRule = typeof recurrence !== 'undefined' && recurrence.length
        ? getRecurrenceByRule(recurrence[0], t, groupByStartDate, weekStarter)
        : '';
    return (React.createElement("div", { className: classes.TimeContainer },
        React.createElement(TimeIcon, null),
        React.createElement("div", { className: classes.FlexTimeContainer },
            React.createElement(Text, { className: classes.Time, key: "primary", priority: TextPriority.primary }, time),
            recurrence ? (React.createElement(Text, { className: classes.Recurrence }, recurrenceByRule)) : null)));
};
export default React.memo(ExpandedTime);
//# sourceMappingURL=ExpandedTime.js.map